import ApplicationController from './application_controller'

export default class extends ApplicationController {
  openModal(event) {
    const id = event.currentTarget.dataset.modalId;
    document.getElementById(id).classList.remove("hidden")
  }
  closeModal(event) {
    const id = event.currentTarget.dataset.modalId;
    document.getElementById(id).classList.add("hidden")
  }
}

